// namespace
export const AUTH_NAMESPACE = 'auth'

// getters
export const AUTH_GETTER_IDTOKEN = 'getIdToken'

// mutations
export const AUTH_MUTATION_LOG_IN = 'logIn'
export const AUTH_MUTATION_LOG_OUT = 'logOut'
export const AUTH_MUTATION_SET_IDTOKEN = 'setIdToken'
export const AUTH_MUTATION_SIGN_UP = 'signUp'

// actions
export const AUTH_ACTION_LOG_IN = 'logUserIn'
export const AUTH_ACTION_LOG_OUT = 'logUserOut'
export const AUTH_ACTION_REQUEST_IDTOKEN = 'requestIdToken'
export const AUTH_ACTION_SIGN_UP = 'signUserUp'

export const AUTH_ACTION_RECOVER_PASSWORD = 'recoverPassword'



// WEBPACK FOOTER //
// ./src/store/modules/auth-types.js